var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommercialDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 200,
    viewBox: "0 0 251 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.887 45V51",
    stroke: "#73F5CF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.887 59V65",
    stroke: "#73F5CF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.887 55H168.887",
    stroke: "#73F5CF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.887 55H182.887",
    stroke: "#73F5CF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8867 148V152",
    stroke: "#73F5CF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8867 160V164",
    stroke: "#73F5CF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8867 156H85.8867",
    stroke: "#73F5CF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8867 156H97.8867",
    stroke: "#73F5CF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.098 131.126C162.489 129.423 163.739 127.642 164.848 125.799C167.288 121.744 169.046 117.388 170.121 112.897C171.208 108.356 171.596 103.676 171.281 99.0296C171.007 94.9756 170.198 90.9475 168.852 87.0598C167.517 83.2028 165.654 79.484 163.262 76.015C161.836 73.9479 160.223 71.9696 158.42 70.1036C155.775 67.364 152.872 65.0219 149.789 63.0787C146.475 60.9908 142.953 59.3634 139.313 58.1984C134.755 56.7393 130.014 56.0054 125.273 56C121.583 55.9959 117.894 56.4328 114.289 57.3125C110.231 58.3028 106.282 59.8543 102.563 61.9692C99.2944 63.8284 96.2038 66.123 93.3747 68.8547C89.8195 72.2875 86.9397 76.1572 84.738 80.2985C82.5823 84.3531 81.0766 88.6682 80.2233 93.0887C79.3441 97.6429 79.1573 102.309 79.6657 106.918C80.3245 112.891 82.1511 118.768 85.1511 124.179C87.0708 127.641 89.4709 130.912 92.353 133.896C96.9283 138.634 102.27 142.183 107.991 144.535C114.949 147.397 122.467 148.489 129.851 147.8C136.049 147.221 142.151 145.387 147.748 142.29",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M161.098 131.126C162.489 129.423 163.739 127.642 164.848 125.799C167.288 121.744 169.046 117.388 170.121 112.897C171.208 108.356 171.596 103.676 171.281 99.0296C171.007 94.9756 170.198 90.9475 168.852 87.0598C167.517 83.2028 165.654 79.484 163.262 76.015C161.836 73.9479 160.223 71.9696 158.42 70.1036C155.775 67.364 152.872 65.0219 149.789 63.0787C146.475 60.9908 142.953 59.3634 139.313 58.1984C134.755 56.7393 130.014 56.0054 125.273 56C121.583 55.9959 117.894 56.4328 114.289 57.3125C110.231 58.3028 106.282 59.8543 102.563 61.9692C99.2944 63.8284 96.2038 66.123 93.3747 68.8547C89.8195 72.2875 86.9397 76.1572 84.738 80.2985C82.5823 84.3531 81.0766 88.6682 80.2233 93.0887C79.3441 97.6429 79.1573 102.309 79.6657 106.918C80.3245 112.891 82.1511 118.768 85.1511 124.179C87.0708 127.641 89.4709 130.912 92.353 133.896C96.9283 138.634 102.27 142.183 107.991 144.535C114.949 147.397 122.467 148.489 129.851 147.8C136.049 147.221 142.151 145.387 147.748 142.29",
    stroke: "#00D9BE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.088 140.378C153.994 138.508 156.578 136.175 158.259 134.291L151.088 140.378Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.088 140.378C153.994 138.508 156.578 136.175 158.259 134.291",
    stroke: "#00D9BE",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M167.387 104.617C167.101 104.622 166.814 104.625 166.527 104.625C141.273 104.625 120.595 84.9362 118.863 60C98.7619 63.1706 83.3867 80.6526 83.3867 101.743C83.3867 125.081 102.212 144 125.435 144C147.696 144 165.917 126.615 167.387 104.617Z",
    fill: "#74F8BE",
    fillOpacity: 0.12
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.41 100.373C108.187 99.2433 106.289 99.33 105.172 100.567C104.054 101.803 104.14 103.721 105.363 104.851L119.482 117.889C121.195 119.47 123.852 119.349 125.416 117.618C125.481 117.544 125.481 117.544 125.545 117.469L145.693 92.9716C146.753 91.6837 146.579 89.7716 145.305 88.7008C144.031 87.63 142.139 87.806 141.08 89.0939L122.137 112.125L109.41 100.373Z",
    fill: "white",
    stroke: "#00D9BE",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.211 64.4131C109.26 65.1447 107.355 66.0338 105.515 67.0806C102.655 68.7072 99.9516 70.7149 97.4766 73.1049C96.4621 74.0846 95.5105 75.105 94.6218 76.161M91.8718 79.8378C91.1652 80.9057 90.5149 82.0004 89.9209 83.1176C89.4823 83.9428 89.0744 84.7803 88.6973 85.6285",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.65 65.5835C112.296 65.341 112.623 64.6204 112.381 63.974C112.138 63.3277 111.418 63.0003 110.772 63.2428L111.65 65.5835ZM105.515 67.0806L106.133 68.1671L105.515 67.0806ZM97.4766 73.1049L96.6083 72.2057L97.4766 73.1049ZM93.6653 75.3562C93.2208 75.8844 93.2887 76.6729 93.8169 77.1174C94.3451 77.5619 95.1336 77.4941 95.5782 76.9659L93.6653 75.3562ZM92.9143 80.5277C93.2952 79.9519 93.1374 79.1764 92.5617 78.7954C91.986 78.4144 91.2104 78.5723 90.8294 79.148L92.9143 80.5277ZM89.9209 83.1176L91.0247 83.7044L91.0247 83.7044L89.9209 83.1176ZM87.5551 85.1206C87.2746 85.7515 87.5586 86.4902 88.1894 86.7707C88.8203 87.0511 89.559 86.7671 89.8395 86.1363L87.5551 85.1206ZM110.772 63.2428C108.76 63.9973 106.795 64.9143 104.897 65.994L106.133 68.1671C107.916 67.1532 109.761 66.2921 111.65 65.5835L110.772 63.2428ZM104.897 65.994C101.947 67.672 99.1591 69.7424 96.6083 72.2057L98.3449 74.0041C100.744 71.6874 103.364 69.7425 106.133 68.1671L104.897 65.994ZM96.6083 72.2057C95.5628 73.2154 94.5817 74.2673 93.6653 75.3562L95.5782 76.9659C96.4392 75.9427 97.3614 74.9538 98.3449 74.0041L96.6083 72.2057ZM90.8294 79.148C90.1006 80.2494 89.4298 81.3785 88.8172 82.5309L91.0247 83.7044C91.5999 82.6222 92.2298 81.562 92.9143 80.5277L90.8294 79.148ZM88.8172 82.5309C88.3647 83.382 87.944 84.2459 87.5551 85.1206L89.8395 86.1363C90.2047 85.3148 90.5998 84.5036 91.0247 83.7044L88.8172 82.5309Z",
    fill: "#73F5CF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialDone);
export default __webpack_public_path__ + "static/media/commercial-done.3a718e1cad4f2b73b3240c4c3fb5d93d.svg";
export { ForwardRef as ReactComponent };